import { SideNavInterface } from '../../interfaces/side-nav.type';
export const ROUTES: SideNavInterface[] = [
    {
        path: '',
        title: 'Dashboard',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'dashboard',
        submenu: []
    },
    {
        path: '',
        title: 'Dali',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'code',
        submenu: [
            {
                path: 'apps/dali',
                title: 'Dashboard',
                iconType: 'nzIcon',
                iconTheme: 'outline',
                icon: 'dashboard',
                submenu: []
             }//TEMPORARY,{
            //     path: 'apps/dali/settings',
            //     title: 'Settings',
            //     iconType: 'nzIcon',
            //     iconTheme: 'outline',
            //     icon: 'setting',
            //     submenu: []
            // }
        ]
    },
    {
        path: '',
        title: 'Manage',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'control',
        submenu: [
            {
                path: 'apps/projects',
                title: 'Projects',
                iconType: 'nzIcon',
                iconTheme: 'outline',
                icon: 'project',
                submenu: []
            },
            {
                path: 'apps/leads',
                title: 'Leads',
                iconType: 'nzIcon',
                iconTheme: 'outline',
                icon: 'idcard',
                submenu: []
            },
            {
                path: 'apps/smimesh-uploader',
                title: 'Smimesh Uploader',
                iconType: 'nzIcon',
                iconTheme: 'outline',
                icon: 'cloud-upload',
                submenu: []
            }
        ]
    },
    {
        path: 'apps/reports',
        title: 'Reports',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'fund',
        submenu: [
            {
                path: 'apps/downloadleads',
                title: 'Download Leads',
                iconType: 'nzIcon',
                iconTheme: 'outline',
                icon: 'download',
                submenu: []
            },
            {
                path: 'apps/audit-grid',
                title: 'Jornaya Lead Audit',
                iconType: 'nzIcon',
                iconTheme: 'outline',
                icon: 'safety-certificate',
                submenu: []
            },
            {
                path: 'apps/audit-dashboard',
                title: 'Jornaya Analytics',
                iconType: 'nzIcon',
                iconTheme: 'outline',
                icon: 'pie-chart',
                submenu: []
            },
        ]
    },
    {
        path: 'apps/externalreports',
        title: 'External Reports',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'console-sql',
        submenu: []

    },
    {
        path: '/setting',
        title: 'Setting',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'setting',
        submenu: [
            {
                path: 'apps/leadsource',
                title: 'Lead Source',
                iconType: 'nzIcon',
                iconTheme: 'outline',
                icon: 'audit',
                submenu: []
            },
        ]
    },
    {
        path: 'apps/system-logs',
        title: 'System Logs',
        iconType: 'nzIcon',
        iconTheme: 'outline',
        icon: 'monitor',
        submenu: []
    }
];
